import MapNJ from 'mapnj';

class PetAreaMap {
  constructor() {
    this.elm = document.querySelector('[data-role="pet-area-map"]');

    if (!this.elm) return;

    this.link = {
      agatuma: this.elm.dataset.pathAgatuma,
      tonenumata: this.elm.dataset.pathTonenumata,
      west: this.elm.dataset.pathWest,
      kenou: this.elm.dataset.pathKenou,
      east: this.elm.dataset.pathEast,
    };

    this.mapnj = new MapNJ('#pet-areas-mapnj-vectors', {
      areaDefaultFillColors: {
        agatuma: '#E8B7CE',
        tonenumata: '#CBCAE8',
        east: '#F1CFB8',
        west: '#F3EDBC',
        kenou: '#D8E5D4',
      },
      transparentDefaultLabels: true,
    });

    this.mapnj.on('AREA_CHANGE', (mapnj) => {
      const id = mapnj.state.activeAreaId;
      const link = this.link[id];

      window.open(link, '_blank');
    });
  }
}

export default PetAreaMap;
